import { render } from "./EmployeeShow.vue?vue&type=template&id=0d582b7b"
import script from "./EmployeeShow.vue?vue&type=script&lang=js"
export * from "./EmployeeShow.vue?vue&type=script&lang=js"

import "./EmployeeShow.vue?vue&type=style&index=0&id=0d582b7b&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__